import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import type { FlowType } from "@redotech/redo-return-core-common/return-flow-enums";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { flowEditorHref } from "./parse-flow-edit-preview";

/**
 * Action row under a staged (saved-not-published) flow edit result: the
 * changes are waiting in the flow editor, so offer the trip there.
 */
export const FlowStagedActions = memo(function FlowStagedActions({
  flowType,
  disabled,
}: {
  flowType: FlowType;
  disabled: boolean;
}) {
  const team = useContext(TeamContext);
  const navigate = useNavigate();
  const editorHref = team ? flowEditorHref(team._id, flowType) : undefined;
  const openEditor = useCallback(() => {
    if (editorHref) {
      navigate(editorHref);
    }
  }, [editorHref, navigate]);

  if (!editorHref) {
    return null;
  }
  return (
    <Flex justify="flex-start">
      <RedoButton
        disabled={disabled}
        hierarchy="secondary"
        onClick={openEditor}
        size="sm"
        text="Open flow editor"
      />
    </Flex>
  );
});
